import { render, staticRenderFns } from "./BannerWhite.vue?vue&type=template&id=2611771d&"
import script from "./BannerWhite.vue?vue&type=script&lang=js&"
export * from "./BannerWhite.vue?vue&type=script&lang=js&"
import style0 from "./BannerWhite.vue?vue&type=style&index=0&id=2611771d&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports